import { Component, OnInit, OnDestroy } from '@angular/core';
import { Response } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager, ParseLinks, PaginationUtil, JhiLanguageService, AlertService } from 'ng-jhipster';

import { AuthRequestBnbaccess } from './auth-request-bnbaccess.model';
import { AuthRequestBnbaccessService } from './auth-request-bnbaccess.service';
import { ITEMS_PER_PAGE, Principal } from '../../shared';
import { PaginationConfig } from '../../blocks/config/uib-pagination.config';

@Component({
    selector: 'jhi-auth-request-bnbaccess',
    templateUrl: './auth-request-bnbaccess.component.html'
})
export class AuthRequestBnbaccessComponent implements OnInit, OnDestroy {
authRequests: AuthRequestBnbaccess[];
    currentAccount: any;
    eventSubscriber: Subscription;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private authRequestService: AuthRequestBnbaccessService,
        private alertService: AlertService,
        private eventManager: EventManager,
        private principal: Principal
    ) {
        this.jhiLanguageService.setLocations(['authRequest']);
    }

    loadAll() {
        this.authRequestService.query().subscribe(
            (res: Response) => {
                this.authRequests = res.json();
            },
            (res: Response) => this.onError(res.json())
        );
    }
    ngOnInit() {
        this.loadAll();
        this.principal.identity().then((account) => {
            this.currentAccount = account;
        });
        this.registerChangeInAuthRequests();
    }

    ngOnDestroy() {
        this.eventManager.destroy(this.eventSubscriber);
    }

    trackId (index: number, item: AuthRequestBnbaccess) {
        return item.id;
    }



    registerChangeInAuthRequests() {
        this.eventSubscriber = this.eventManager.subscribe('authRequestListModification', (response) => this.loadAll());
    }


    private onError (error) {
        this.alertService.error(error.message, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/auth-request/auth-request-bnbaccess.component.ts